import styled from '@emotion/styled';
import { SwitcherLabelWrapper } from 'src/components/FormComponents/SwitcherWithLabel/SwitcherWithLabel.style';

export const BetReferralSwitcherLabelWrapper = styled(SwitcherLabelWrapper, { label: 'BetReferralSwitcherLabelWrapper' })`
    gap: 8px;
`;
